module.exports = __webpack_public_path__ + "static/img/equip-4.c847c61b.png";